module.exports = __webpack_public_path__ + "static/media/copyIcon.00019172.svg";